import { useState } from "react";
import { FaHandHoldingUsd, FaHandsHelping, FaFileAlt, FaMoneyCheckAlt, FaIdCard } from "react-icons/fa";

import { Card, Carousel, CarouselIndicators, Modal } from "../components/carousel";

import icon_1 from "../assets/icons/Adli_Tip_Teknolojileri.png";
import icon_2 from "../assets/icons/Afetlere_Hazirlik.png";
import icon_3 from "../assets/icons/Akilli_Sehir.jpg";
import icon_4 from "../assets/icons/Biyometrik_Sistemler.png";
import icon_5 from "../assets/icons/Butunlesik_Guvenlik_Sistemler.png";
import icon_6 from "../assets/icons/Deprem_Oncesi_Sonrasi.png";
import icon_7 from "../assets/icons/Gozetleme.jpg";
import icon_8 from "../assets/icons/Iletisim_Haberlesme.jpg";
import icon_9 from "../assets/icons/Siber_Guvenlik_ve_Dijital_Guven_Teknolojileri.png";
import icon_10 from "../assets/icons/Yapay_Zeka_ve_Karar_Destek_Sistemleri.jpg";
import icon_11 from "../assets/icons/KBRN_ve_Kritik_Tehdit_Teknolojileri.png";
import icon_12 from "../assets/icons/Otonom_Sistemler_Robotik_ve_İleri_Sensör_Teknolojileri.png";
import icon_13 from "../assets/icons/iletisim_ve_haberlesme_v2.png";

const Anasayfa = () => {
  const [selectedCard, setSelectedCard] = useState(null);

  const cardData = [
  {
    alt: "Advanced Security Technologies",
    title: "Advanced Security Technologies",
    src: icon_5,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Advanced Tracking and Surveillance</li>
        <li class="list-group-item">Video Analytics and Image Processing</li>
        <li class="list-group-item">Threat and Suspicious Behavior Analytics</li>
        <li class="list-group-item">Mobile Surveillance Systems</li>
        <li class="list-group-item">Remote Monitoring and Command Centers</li>
        <li class="list-group-item">Smart Camera and Sensor Systems</li>
        <li class="list-group-item">Security Operations Platforms</li>
      </ul>
  },
  {
    alt: "Cybersecurity and Digital Trust Technologies",
    title: "Cybersecurity and Digital Trust Technologies",
    src: icon_9,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Cybersecurity and Cyber Intelligence</li>
        <li class="list-group-item">Threat Hunting and Intrusion Detection</li>
        <li class="list-group-item">Authentication and Access Control</li>
        <li class="list-group-item">Cryptography and Encryption</li>
        <li class="list-group-item">Blockchain-Based Systems</li>
        <li class="list-group-item">Digital Identity and Data Security</li>
        <li class="list-group-item">Cloud Security and Zero Trust Network Architecture</li>
      </ul>
  },
  {
    alt: "Artificial Intelligence and Decision Support Systems",
    title: "Artificial Intelligence and Decision Support Systems",
    src: icon_10,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Artificial Intelligence Applications</li>
        <li class="list-group-item">Machine Learning and Deep Learning</li>
        <li class="list-group-item">Big Data Analytics</li>
        <li class="list-group-item">Predictive Analytics</li>
        <li class="list-group-item">Autonomous Decision Support Systems</li>
        <li class="list-group-item">Generative Artificial Intelligence</li>
        <li class="list-group-item">Operational Decision Support</li>
        <li class="list-group-item">Risk Analysis and Scenario Management</li>
      </ul>
  },
  {
    alt: "Biometric and Identity Technologies",
    title: "Biometric and Identity Technologies",
    src: icon_4,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Face, Voice, Fingerprint, Iris, and Retina Recognition</li>
        <li class="list-group-item">Gesture and Facial Expression Recognition</li>
        <li class="list-group-item">Gait and Behavioral Analysis</li>
        <li class="list-group-item">Multimodal Biometric Authentication</li>
        <li class="list-group-item">Behavioral Biometrics</li>
        <li class="list-group-item">Digital Identity Management</li>
        <li class="list-group-item">Contactless Access Control Systems</li>
      </ul>
  },
  {
    alt: "Communication Technologies",
    title: "Communication Technologies",
    src: icon_13,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Secure Communication Systems</li>
        <li class="list-group-item">Satellite Communications</li>
        <li class="list-group-item">Tactical and Mission-Critical Communications</li>
        <li class="list-group-item">Wireless Communication Technologies</li>
        <li class="list-group-item">Encryption and Cryptographic Solutions</li>
        <li class="list-group-item">IoT Security and Network Security</li>
        <li class="list-group-item">Secure 5G / 6G Infrastructures</li>
        <li class="list-group-item">Emergency Communication Systems</li>
      </ul>
  },
  {
    alt: "Smart City, Traffic, and Critical Infrastructure Technologies",
    title: "Smart City, Traffic, and Critical Infrastructure Technologies",
    src: icon_3,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Smart City Solutions</li>
        <li class="list-group-item">Smart Mobility and Traffic Control Systems</li>
        <li class="list-group-item">Traffic Radars and Smart Intersections</li>
        <li class="list-group-item">License Plate and Vehicle Recognition Systems</li>
        <li class="list-group-item">Smart Parking and Transportation Systems</li>
        <li class="list-group-item">Critical Infrastructure Security</li>
        <li class="list-group-item">Energy and Infrastructure Security</li>
        <li class="list-group-item">Digital Twin and City Data Platforms</li>
      </ul>
  },
  {
    alt: "Forensic Sciences and Crime Scene Technologies",
    title: "Forensic Sciences and Crime Scene Technologies",
    src: icon_1,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Crime Scene Investigation</li>
        <li class="list-group-item">Forensic Medicine and Forensic Technology</li>
        <li class="list-group-item">Biological Material Analysis</li>
        <li class="list-group-item">Digital Forensics</li>
        <li class="list-group-item">Forensic Multimedia Analysis</li>
        <li class="list-group-item">Evidence Management Systems</li>
        <li class="list-group-item">Traffic and Insurance Forensic Investigations</li>
        <li class="list-group-item">Narcotic Analysis Technologies</li>
      </ul>
  },
  {
    alt: "Migration, Border, and Public Safety Technologies",
    title: "Migration, Border, and Public Safety Technologies",
    src: icon_7,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Border Security Systems</li>
        <li class="list-group-item">Immigration Control and Border Monitoring Systems</li>
        <li class="list-group-item">Smart Border and Border Control Systems</li>
        <li class="list-group-item">Biometric Access and Identity Verification</li>
        <li class="list-group-item">Risk Assessment and Threat Monitoring Systems</li>
        <li class="list-group-item">Public Order and Crowd Management</li>
        <li class="list-group-item">High-Value Asset and Personal Protection Systems</li>
      </ul>
  },
  {
    alt: "Disaster, Crisis, and Emergency Management Technologies",
    title: "Disaster, Crisis, and Emergency Management Technologies",
    src: icon_6,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Early Warning and Monitoring Systems</li>
        <li class="list-group-item">Disaster and Crisis Management Platforms</li>
        <li class="list-group-item">Search and Rescue Technologies</li>
        <li class="list-group-item">UAV-Assisted Disaster Management</li>
        <li class="list-group-item">Location Tracking and Monitoring Systems</li>
        <li class="list-group-item">Through-the-Wall Imaging Systems</li>
        <li class="list-group-item">Disaster Simulation and Scenario Analysis</li>
        <li class="list-group-item">Post-Disaster Logistics and Coordination</li>
      </ul>
  },
  {
    alt: "CBRN and Critical Threat Detection Technologies",
    title: "CBRN and Critical Threat Detection Technologies",
    src: icon_11,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">Decontamination Systems</li>
        <li class="list-group-item">Sampling and Identification Technologies</li>
        <li class="list-group-item">Nuclear Threat Monitoring</li>
        <li class="list-group-item">Explosive Detection and Disposal Systems</li>
        <li class="list-group-item">Contraband and Illicit Substance Detection</li>
        <li class="list-group-item">X-Ray and Millimeter Wave Screening Systems</li>
        <li class="list-group-item">Advanced Scanners and Detectors</li>
        <li class="list-group-item">Hazardous Material Sensor Systems</li>
        <li class="list-group-item">CBRN Protection and Analysis Solutions</li>
      </ul>
  },
  {
    alt: "Autonomous Systems, Robotics, and Advanced Sensor Technologies",
    title: "Autonomous Systems, Robotics, and Advanced Sensor Technologies",
    src: icon_12,
    description: 
      <ul class="list-group list-group-flush">
        <li class="list-group-item">UAV / UAS Systems</li>
        <li class="list-group-item">Autonomous Underwater and Surface Vehicles</li>
        <li class="list-group-item">Robotic Intervention and Patrol Systems</li>
        <li class="list-group-item">Sensor Fusion and Smart Sensor Networks</li>
        <li class="list-group-item">LiDAR, RADAR, and Electro-Optical Systems</li>
        <li class="list-group-item">Remote Sensing and Positioning</li>
        <li class="list-group-item">Autonomous Navigation and Control</li>
        <li class="list-group-item">Intelligent Robotic Platforms</li>
      </ul>
  }]
  return (
    <div className="mt-4 pt-4">
      
      <Carousel />

      <section className="my-4 py-4">
        <div className="row my-4 py-4 header-hero header-hero-top">
          <div className="col text-center">
            <h2>Focus Technologies</h2>
          </div>
        </div>

        <div className="cards">
          {cardData.map((card, index) => (
            <Card
              key={index}
              alt={card.alt}
              src={card.src}
              title={card.title}
              onOpen={() => setSelectedCard(card)}
            />
          ))}
        </div>

        <Modal
          show={!!selectedCard}
          title={selectedCard?.title}
          description={selectedCard?.description}
          onClose={() => setSelectedCard(null)}
        />
      </section>
      
      {/* <section className="my-4 py-4">
        <div className="row my-4 py-4 header-hero header-hero-top">
          <div className="col text-center">
            <h2>Haberler</h2>
          </div>
        </div>

        <CarouselIndicators />

      </section> */}

    </div>
  );
};

export default Anasayfa;
